import { gql } from '@apollo/react-hooks';

import {
  type FetchResult,
  type MutationFunctionOptions,
  useMutation,
} from '@apollo/client';

export const useUpdateInterviewPanelMember = (
  options?: MutationFunctionOptions,
): ((options?: MutationFunctionOptions) => Promise<FetchResult>) => {
  const [updateInterviewPanelMember] = useMutation(
    gql`
      mutation ($input: CreateInterviewPanelInput!) {
        createScholarshipInterviewPanel(input: $input) {
          __typename
        }
      }
    `,
    {
      ...options,
    },
  );

  return updateInterviewPanelMember;
};
